import { type ExternalResponse, type Response } from './model';

export default function adapter(externalResponse: ExternalResponse) {
  const response: Response = {
    data: {
      id: externalResponse.id,
      type: externalResponse.type,
      createdAt: externalResponse.created_at,
      expiresAt: externalResponse.expires_at,
      card: {
        brand: externalResponse.card.brand,
        expMonth: externalResponse.card.exp_month,
        expYear: externalResponse.card.exp_year,
        firstSixDigits: externalResponse.card.first_six_digits,
        holderName: externalResponse.card.holder_name,
        lastFourDigits: externalResponse.card.last_four_digits,
      },
    },
  };

  return response;
}
